import Typography from '@repo/ui/typography'

import {
  AffectedStaffProperties,
  CenterInformationInput
} from '../../../lib/types/models/affectedStaff/properties.affected-staff'
import CountryFlag from '../../elements/country-flag'
import PeriodBadge from '../../elements/period-badge'

type Props = {
  center: CenterInformationInput
}

const AffectedStaffCenterDetailsBadge = ({ center }: Props) => {
  const centerData = AffectedStaffProperties.getCenterInformation(center)
  return centerData.map((centerData, index) => (
    <PeriodBadge
      key={index}
      period={centerData.period}
      text={
        <div className="flex gap-2 items-center">
          {centerData.country && <CountryFlag possibleCountry={centerData.country} />}
          <Typography variant="label-medium">{centerData.details.join(' - ')}</Typography>
        </div>
      }
    />
  ))
}

export default AffectedStaffCenterDetailsBadge
